/**
 * Mini-graphe interactif — EX-15
 * Affiché pour query_type "relational" ou "mixed".
 * Nœuds cliquables → affiche le chunk source dans SourcePanel.
 */
import React, { useCallback, useRef } from "react";

// react-force-graph-2d chargé dynamiquement pour éviter SSR issues
let ForceGraph2D = null;
try {
  ForceGraph2D = require("react-force-graph-2d").default;
} catch {
  ForceGraph2D = null;
}

const TYPE_COLORS = {
  Person: "#4f8ef7",
  Organization: "#f7934f",
  Location: "#4ff78e",
  Concept: "#f74f8e",
  Method: "#8ef74f",
  Product: "#f7f44f",
  Regulation: "#b04ff7",
  default: "#aaaaaa",
};

export default function MiniGraph({ nodes = [], edges = [], onNodeClick }) {
  const graphRef = useRef(null);

  const graphData = {
    nodes: nodes.map((n) => ({
      ...n,
      color: TYPE_COLORS[n.type] || TYPE_COLORS.default,
    })),
    links: edges.map((e) => ({
      source: e.source,
      target: e.target,
      type: e.type,
      value: e.weight || 1,
    })),
  };

  const handleNodeClick = useCallback(
    (node) => {
      if (onNodeClick) onNodeClick(node);
    },
    [onNodeClick]
  );

  if (!ForceGraph2D) {
    return (
      <div className="mini-graph mini-graph--fallback">
        <p>Graphe : {nodes.length} entités, {edges.length} relations</p>
        <ul>
          {edges.slice(0, 8).map((e, i) => (
            <li key={i}>
              {e.source} → <em>{e.type}</em> → {e.target}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  if (!nodes.length) return null;

  return (
    <div className="mini-graph">
      <div className="mini-graph__header">
        <span>🕸️ Graphe des relations</span>
        <small>{nodes.length} entités · {edges.length} relations</small>
      </div>
      <ForceGraph2D
        ref={graphRef}
        graphData={graphData}
        width={460}
        height={280}
        nodeLabel={(n) => `${n.label} (${n.type})`}
        nodeColor={(n) => n.color}
        linkLabel={(l) => l.type}
        linkDirectionalArrowLength={4}
        linkDirectionalArrowRelPos={1}
        onNodeClick={handleNodeClick}
        nodeCanvasObject={(node, ctx, globalScale) => {
          const label = node.label || node.id;
          const fontSize = 10 / globalScale;
          ctx.font = `${fontSize}px Sans-Serif`;
          ctx.fillStyle = node.color;
          ctx.beginPath();
          ctx.arc(node.x, node.y, 5, 0, 2 * Math.PI);
          ctx.fill();
          ctx.fillStyle = "#333";
          ctx.fillText(label, node.x + 7, node.y + 4);
        }}
      />
    </div>
  );
}
